import { Link } from "react-router-dom";
import { Icon } from "@mui/material";
import { PlanCuidadoContext } from "../../../context/PlanCuidadoContextProvider";
import { useContext, useEffect, useState } from "react";
import { Modal, Button, message, Select } from "antd";
import React from "react";
import { morning_img_02 } from "../../imagepath";
import { getPlans } from "../../../services/dim";
import { extractPatientIdFromUrl } from "../../../utils/helpers";
import { get, post } from "../../../services/base";
import {planesCuidadoCode} from "../../../utils/enums/statusCodes";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { actualizarPlanCuidadoEstatus } from "../../../services/planes";
import metasType from "../../../utils/enums/metasTypes";
import { crearActividades } from "../../../services/actividades";

const Planes = () => {
  const { planesCuidadoData, updatePlanesCuidadoData, listado } =
    useContext(PlanCuidadoContext);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalEditarVisible, setModalEditarVisible] = useState(false);
  const [modalPlanEditar, setModalPlanEditar] = useState(false);
  const [modalActividadesEditar, setModalActividadesEditar] = useState([]);
  const [modalCitasEditar, setModalCitasEditar] = useState([]);
  const [
    modalActividadesFormateadasEditar,
    setModalActividadesFormateadasEditar,
  ] = useState([]);
  const [modalCitasFormateadasEditar, setModalCitasFormateadasEditar] =
    useState([]);

  const [loading, setLoading] = useState(false);
  const [activitiesAndAppointments, setActivitiesAndAppointments] = useState({
    actividades: [],
    citas: [],
  });
  const [selectedOption, setSelectedOption] = useState(null);

  const gestor = localStorage.getItem("username");

  const onChangeStatus = async (id, codigoEstatus, estatus) => {
    try {
      const { confirm } = Modal;
      confirm({
        title: "Actualización Estado Paciente",
        icon: <ExclamationCircleFilled />,
        content:
          "¿Está seguro que desea actualizar el plan de cuidado del paciente a " +
          estatus +
          "?",
        okText: "Si",
        cancelText: "No",
        onOk() {
          return new Promise((resolve, reject) => {
            actualizarPlanCuidadoEstatus({ id, codigoEstatus }).then(() => {
              updatePlanesCuidadoData();
              resolve();
            });
          }).catch(() => console.log("Oops errors!"));
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    } catch (error) {
      console.error(error);
    }
  };
  const handlePlanSelection = async (selected) => {
    setSelectedOption(selected);
    try {
      const response = await post(
        "/PlanesCuidado/actividades/listado",
        JSON.stringify({ codigoPlan: selected.toString() })
      );
      const data = response.data[0];

      const formattedData = {
        actividades: data.actividades.map((activity) => ({
          id: activity.id,
          descripcion: activity.descripcion,
          fecha: activity.fecha,
          tipoActividad: activity.tipoActividad,
        })),
        citas: data.citas.map((cita) => ({
          id: cita.id,
          descripcion: cita.descripcion,
          fecha: cita.fecha,
          tipoActividad: cita.tipoActividad,
        })),
      };
      setActivitiesAndAppointments(formattedData);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleCerrarAgregarPlan = (event) => {
    const checkboxesActivities = document.querySelectorAll(
      'input[id^="activity-"]'
    );
    checkboxesActivities.forEach((checkbox) => {
      checkbox.checked = false;
    });

    const checkboxesAppointments = document.querySelectorAll(
      'input[id^="appointment-"]'
    );
    checkboxesAppointments.forEach((checkbox) => {
      checkbox.checked = false;
    });
    setSelectedOption(null);
    setModalVisible(false);
    setLoading(false);
  };

  const handlerModalEditar = async (plan) => {
    if (!modalEditarVisible) {
      setModalEditarVisible(true);
    }
    setModalPlanEditar(plan.id);
    setModalActividadesEditar(plan.actividades);
    setModalCitasEditar(plan.citas);

    try {
      const response = await post(
        "/PlanesCuidado/actividades/listado",
        JSON.stringify({ descripcion: plan.tipo })
      );
      const data = response.data[0];
      const formattedData = {
        actividades: data.actividades.map((activity) => ({
          id: activity.codigo,
          actividadDe: activity.descripcion,
          fecha: activity.fecha,
          tipoActividad: activity.tipoActividad,
        })),
        citas: data.citas.map((cita) => ({
          id: cita.codigo,
          actividadDe: cita.descripcion,
          fecha: cita.fecha,
          tipoActividad: cita.tipoActividad,
        })),
      };

      const actividadesAsignadas = plan.actividades.map((activity) => ({
        ...activity,
        tipo: "actividad",
      }));
      const citasAsignadas = plan.citas.map((cita) => ({
        ...cita,
        tipo: "cita",
      }));

      const actividadesUnidas = [
        ...actividadesAsignadas,
        ...formattedData.actividades,
      ];
      const citasUnidas = [...citasAsignadas, ...formattedData.citas];

      const actividadesSinDuplicados = [
        ...new Set(actividadesUnidas.map((activity) => activity.actividadDe)),
      ].map((actividadDe) =>
        actividadesUnidas.find(
          (activity) => activity.actividadDe === actividadDe
        )
      );
      const citasSinDuplicados = [
        ...new Set(citasUnidas.map((cita) => cita.actividadDe)),
      ].map((actividadDe) =>
        citasUnidas.find((cita) => cita.actividadDe === actividadDe)
      );
      setModalActividadesFormateadasEditar(actividadesSinDuplicados);
      setModalCitasFormateadasEditar(citasSinDuplicados);
    } catch (error) {
      console.error("Error:", error);
    }

    setLoading(false);
  };

  const handleAgregarActividadesEditadas = async () => {
    try {
      setLoading(true);

      // Obtener las actividades y citas marcadas pero no desactivadas
      const checkboxesActivities = document.querySelectorAll(
        'input[id^="activity-editada-"]:checked:not(:disabled)'
      );
      const checkboxesAppointments = document.querySelectorAll(
        'input[id^="appointment-editado-"]:checked:not(:disabled)'
      );

      console.log(checkboxesActivities);
      const selectedActivities = Array.from(checkboxesActivities).map(
        (checkbox) => {
            const idParts = checkbox.id.split("activity-editada-");
            const id = idParts.length > 1 ? idParts[1] : "";
            const label = document.querySelector(
                `label[for=activity-editada-${id}]`
            );
            const text = label ? label.textContent.trim() : "";
            return {
                id: id,
                text: text,
            };
        }
    );

      const selectedAppointments = Array.from(checkboxesAppointments).map(
        (checkbox) => {
          const idParts = checkbox.id.split("appointment-editado-");
          const id = idParts.length > 1 ? idParts[1] : "";
          const label = document.querySelector(
            `label[for=appoinment-editado-${id}]`
          );
          const text = label ? label.textContent.trim() : "";
          return {
            id: id,
            text: text,
          };
        }
      );

      const actividades = [...selectedActivities, ...selectedAppointments];
      const dataToSend = actividades.map((actividad) => ({
        codigoPlan: modalPlanEditar,
        codigoActividad: actividad.id.toString(),
        descripcionActividad: actividad.text,
        codigoMeta: metasType.MA01.value,
        responsable: gestor,
        fechaLimite: new Date().toISOString(),
        meta: "",
      }));

      await crearActividades(modalPlanEditar, JSON.stringify(dataToSend));

      setLoading(false);
      message.success(`Estrategia de cuidado editado exitosamente!`);
      handleCancelarEditadoActividad();
      updatePlanesCuidadoData();
    } catch (error) {
      console.error("Error al agregar la Estrategia de Cuidado:", error);
    }
  };

  const handleAgregarEstrategias = async () => {
    try {
      setLoading(true);
      const checkboxesActivities = document.querySelectorAll(
        'input[id^="activity-"]:checked'
      );
      const checkboxesAppointments = document.querySelectorAll(
        'input[id^="appointment-"]:checked'
      );
      const activitiesIds = Array.from(checkboxesActivities).map((checkbox) =>
        parseInt(checkbox.id.split("-")[1], 10)
      );

      const appointmentIds = Array.from(checkboxesAppointments).map(
        (checkbox) => parseInt(checkbox.id.split("-")[1], 10)
      );

      if (activitiesIds.length === 0 && appointmentIds.length === 0) {
        return;
      }

      // Concatenar las citas seleccionadas a la lista de IDs de actividades
      const allIds = [...activitiesIds, ...appointmentIds];

      await post(
        "/PlanesCuidado",
        JSON.stringify({
          codigo: selectedOption.toString(),
          actividades: allIds,
          afiliado: extractPatientIdFromUrl(),
        })
      );
      setLoading(false);
      message.success(`Estrategia de cuidado agregada exitosamente!`);
      updatePlanesCuidadoData();
      handleCerrarAgregarPlan();
    } catch (error) {
      console.error("Error al agregar el Estrategia de Cuidado:", error);
    }
  };
  const handleCancelarEditadoActividad = async () => {
    setModalEditarVisible(false);
  };
  return (
    <div>
      <button
        type="button"
        className="btn btn-outline-primary mb-3"
        onClick={() => setModalVisible(true)}
      >
        <Icon
          sx={{
            fontSize: "large",
            verticalAlign: "middle",
            marginRight: "5px",
          }}
        >
          add_circle
        </Icon>
        Agregar Estrategias de Cuidado
      </button>
      <div style={{ display: "flex", justifyContent: "center" }}>
        {planesCuidadoData && planesCuidadoData.length > 0 ? (
          planesCuidadoData.map((plan, index) => (
            <div className="card" key={index} style={{ marginRight: "10px" }}>
              <div
                className="card-header pb-0"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <h4 className="card-title d-inline-block">{plan.tipo}</h4>
                <div>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary me-2"
                    onClick={() => handlerModalEditar(plan)}
                  >
                    <Icon
                      sx={{
                        fontSize: "large",
                        verticalAlign: "middle",
                        marginRight: "5px",
                      }}
                    >
                      edit
                    </Icon>
                    Editar
                  </button>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={() =>
                      onChangeStatus(
                        plan.id,
                        planesCuidadoCode.Eliminado.value,
                        planesCuidadoCode.Eliminado.text
                      )
                    }
                  >
                    <Icon
                      sx={{
                        fontSize: "large",
                        verticalAlign: "middle",
                        marginRight: "5px",
                        color: "rgb(255, 153, 153)",
                      }}
                    >
                      delete
                    </Icon>
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="progress">
                  <div
                    className="progress-bar"
                    role="progressbar"
                    style={{ width: `${plan.porcentaje}%` }}
                    aria-valuenow={plan.porcentaje}
                    aria-valuemin={0}
                    aria-valuemax={100}
                  >
                    {plan.porcentaje}%
                  </div>
                </div>
                <br />
                <small style={{ marginTop: "10px" }}>
                  <Icon
                    sx={{
                      fontSize: "large",
                      verticalAlign: "middle",
                      marginRight: "5px",
                    }}
                  >
                    calendar_today
                  </Icon>
                  Fecha de Enrolamiento: {plan.fechaEnrolamiento}
                </small>
                <br />
                <small>
                  <Icon
                    sx={{
                      fontSize: "large",
                      verticalAlign: "middle",
                      marginRight: "5px",
                    }}
                  >
                    calendar_today
                  </Icon>
                  Fecha de Último Contacto: {plan.fechaUltimoContacto}
                </small>
                <br />
                <small>
                  <Icon
                    sx={{
                      fontSize: "large",
                      verticalAlign: "middle",
                      marginRight: "5px",
                    }}
                  >
                    account_circle
                  </Icon>
                  Gestor: {plan.gestor}
                </small>
                <br />
                <div className="btn-group">
                  <button
                    type="button"
                    className="btn btn-primary dropdown-toggle me-1"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{marginTop:"10px"}}
                  >
                    {plan.estatus}
                  </button>
                  <div className="dropdown-menu">
                    {plan.estatus !== planesCuidadoCode.Activo.text && (
                      <Link
                        className="dropdown-item"
                        to="#"
                        onClick={() =>
                          onChangeStatus(
                            plan.id,
                            planesCuidadoCode.Activo.value,
                            planesCuidadoCode.Activo.text
                          )
                        }
                      >
                        {planesCuidadoCode.Activo.text}
                      </Link>
                    )}
                    {plan.estatus !== planesCuidadoCode.Suspendido.text && (
                      <Link
                        className="dropdown-item"
                        to="#"
                        onClick={() =>
                          onChangeStatus(
                            plan.id,
                            planesCuidadoCode.Suspendido.value,
                            planesCuidadoCode.Suspendido.text
                          )
                        }
                      >
                        {planesCuidadoCode.Suspendido.text}
                      </Link>
                    )}
                    {plan.estatus !== planesCuidadoCode.Finalizado.text && (
                      <Link
                        className="dropdown-item"
                        to="#"
                        onClick={() =>
                          onChangeStatus(
                            plan.id,
                            planesCuidadoCode.Finalizado.value,
                            planesCuidadoCode.Finalizado.text
                          )
                        }
                      >
                        {planesCuidadoCode.Finalizado.text}
                      </Link>
                    )}
                    {plan.estatus !== planesCuidadoCode.Inactivo.text && (
                      <Link
                        className="dropdown-item"
                        to="#"
                        onClick={() =>
                          onChangeStatus(
                            plan.id,
                            planesCuidadoCode.Inactivo.value,
                            planesCuidadoCode.Inactivo.text
                          )
                        }
                      >
                        {planesCuidadoCode.Inactivo.text}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div style={{ textAlign: "left", marginLeft: "10px" }}>
            <img src={morning_img_02} alt="No data" />
            <p style={{ marginTop: "10px" }}>
              Este paciente no registra planes de cuidado.
            </p>
          </div>
        )}
      </div>
      <Modal
        title="Agregar Estrategias de Cuidado"
        visible={modalVisible}
        onCancel={handleCerrarAgregarPlan}
        footer={[
          <Button key="cancel" onClick={handleCerrarAgregarPlan}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={!selectedOption}
            loading={loading}
            onClick={handleAgregarEstrategias}
          >
            Agregar
          </Button>,
        ]}
        centered
        style={{
          zIndex: 1042,
        }}
        width={625}
      >
        <div className="row">
          <div className="col-sm-12">
            <br></br>
            <form>
              <div className="row">
                <div className="col-12 col-md-6 col-xl-12">
                  <div className="form-group local-forms">
                    <label>
                      Selecciona el programa al que deseas inscribir al paciente{" "}
                      <span className="login-danger">*</span>
                    </label>
                    <Select
                      id="id-buscar-programa"
                      style={{ width: "100%" }}
                      value={selectedOption}
                      placeholder=""
                      onChange={(selected) => {
                        handlePlanSelection(selected);
                      }}
                    >
                      {listado &&
                        listado.length > 0 &&
                        listado.map((opciones) => (
                          <Option key={opciones.value} value={opciones.value}>
                            {opciones.label}
                          </Option>
                        ))}
                    </Select>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        {/* Mostrar las actividades y citas */}
        {selectedOption && activitiesAndAppointments && (
          <div>
            <h3>Intervenciones</h3>
            <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
              <li style={{ marginBottom: "8px" }}>
                <input
                  type="checkbox"
                  id="selectAllActivities"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const checkboxes = document.querySelectorAll(
                      'input[id^="activity-"]'
                    );
                    checkboxes.forEach(
                      (checkbox) => (checkbox.checked = e.target.checked)
                    );
                  }}
                />
                <label
                  htmlFor="selectAllActivities"
                  style={{
                    marginLeft: "10px",
                    color: "#2481d0",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  Seleccionar todos
                </label>
              </li>
              {activitiesAndAppointments.actividades.map((activity, index) => (
                <li key={activity.id} style={{ marginBottom: "8px" }}>
                  <input
                    type="checkbox"
                    id={`activity-${activity.id}`}
                    style={{ marginRight: "10px" }}
                  />
                  <label
                    htmlFor={`activity-${activity.id}`}
                    style={{ marginLeft: "20px" }}
                  >
                    {activity.descripcion}
                  </label>
                </li>
              ))}
            </ul>

            <h3>Consultas</h3>
            <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
              <li style={{ marginBottom: "8px" }}>
                <input
                  type="checkbox"
                  id="selectAllAppointments"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const checkboxes = document.querySelectorAll(
                      'input[id^="appointment-"]'
                    );
                    checkboxes.forEach(
                      (checkbox) => (checkbox.checked = e.target.checked)
                    );
                  }}
                />
                <label
                  htmlFor="selectAllAppointments"
                  style={{
                    marginLeft: "10px",
                    color: "#2481d0",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  Seleccionar todos
                </label>
              </li>
              {activitiesAndAppointments.citas.map((appointment, index) => (
                <li key={appointment.id} style={{ marginBottom: "8px" }}>
                  <input
                    type="checkbox"
                    id={`appointment-${appointment.id}`}
                    style={{ marginRight: "10px" }}
                  />
                  <label
                    htmlFor={`appointment-${appointment.id}`}
                    style={{ marginLeft: "20px" }}
                  >
                    {appointment.descripcion}
                  </label>
                </li>
              ))}
            </ul>
          </div>
        )}
      </Modal>
      <Modal
        title={<h3>Editar intervenciones para el programa de</h3>}
        visible={modalEditarVisible}
        onCancel={handleCancelarEditadoActividad}
        footer={[
          <Button key="cancel" onClick={handleCancelarEditadoActividad}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleAgregarActividadesEditadas}
          >
            Agregar
          </Button>,
        ]}
        centered
        style={{
          zIndex: 1042,
        }}
        width={625}
      >
        {modalActividadesEditar && (
          <div>
            <br></br>
            <h4>Intervenciones</h4>
            <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
              <li style={{ marginBottom: "16px" }}>
                <input
                  type="checkbox"
                  id="selectAllActivities"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const checkboxes = document.querySelectorAll(
                      'input[id^="activity-editada-"]'
                    );
                    checkboxes.forEach(
                      (checkbox) => (checkbox.checked = e.target.checked)
                    );
                  }}
                />
              </li>
              {modalActividadesFormateadasEditar.map((activity, index) => (
                <li key={activity.id} style={{ marginBottom: "8px" }}>
                  <input
                    type="checkbox"
                    id={`activity-editada-${activity.id}`}
                    style={{ marginRight: "10px" }}
                    disabled={modalActividadesEditar.some(
                      (modalActivity) => modalActivity.id === activity.id
                    )}
                    defaultChecked={modalActividadesEditar.some(
                      (modalActivity) => modalActivity.id === activity.id
                    )}
                  />
                  <label
                    htmlFor={`activity-editada-${activity.id}`}
                    style={{ marginLeft: "20px" }}
                  >
                    <p>{activity.actividadDe}</p>
                  </label>
                </li>
              ))}
            </ul>

            <h4>Consultas</h4>
            <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
              <li style={{ marginBottom: "16px" }}>
                <input
                  type="checkbox"
                  id="selectAllAppointments"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const checkboxes = document.querySelectorAll(
                      'input[id^="appointment-editado-"]'
                    );
                    checkboxes.forEach(
                      (checkbox) => (checkbox.checked = e.target.checked)
                    );
                  }}
                />
              </li>
              {modalCitasFormateadasEditar.map((appointment, index) => (
                <li key={appointment.id} style={{ marginBottom: "8px" }}>
                  <input
                    type="checkbox"
                    id={`appointment-editado-${appointment.id}`}
                    style={{ marginRight: "10px" }}
                    defaultChecked={modalCitasEditar.some(
                      (modalAppointment) =>
                        modalAppointment.id === appointment.id
                    )}
                    disabled={modalCitasEditar.some(
                      (modalAppointment) =>
                        modalAppointment.id === appointment.id
                    )}
                  />
                  <label
                    htmlFor={`appointment-editado-${appointment.id}`}
                    style={{ marginLeft: "20px" }}
                  >
                    {appointment.actividadDe}
                  </label>
                </li>
              ))}
            </ul>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default Planes;
